import React, { type Ref } from 'react';
import { TruncatedTextDiv } from './search-footer-links.styled';

export const ForwardedRefToolTipTag: React.ForwardRefExoticComponent<React.RefAttributes<any>> =
	React.forwardRef((props, ref: Ref<any>) => <TruncatedTextDiv {...props} ref={ref} />);
